export function Footer() {
    const footerElement = document.createElement('footer');
    footerElement.className = 'footer';
    footerElement.innerHTML = `
        <p>&copy; ${new Date().getFullYear()} Sistema de Taquilla Hípica. Todos los derechos reservados.</p>
    `;
    return footerElement;
}